<template>
    <div>
        <transition name="fade" mode="out-in">
            <div v-if="step == 'step-payment'">
                <h3 
                    class="font-weight-bold text-center" 
                    v-if="sender_name"
                    v-text="displayMessage"></h3>
                <div class="position-relative giftcard-form mb-5">
                    <img src="/img/giftcard.jpg" alt="">
                    <h4 class="pass-duration" v-text="__('giftcard.duration')"></h4>
                </div>
            </div>

            <div v-else>
                <h1 class="title">
                    <strong class="text-primary" v-text="__('giftcard.give.baseline')"></strong>
                </h1>
                <br />
                <h2 class="offer-value mb-2" v-text="__('giftcard.give.subline')"></h2>
                <h3 class="offer-price mb-0" v-text="plan.price.formatted"></h3>
                <ul class="benefits-list">
                    <li class="benefit"><img
                            src="/img/style/picto-check.svg">{{ __('trads.Learn-thousands-of-songs') }}
                    </li>
                    <li class="benefit"><img
                            src="/img/style/picto-check.svg">{{ __('trads.New-content-added-every-week') }}
                    </li>
                    <li class="benefit"><img
                            src="/img/style/picto-check.svg">{{ __('trads.Adapted-to-any-level') }}</li>
                    <li class="benefit"><img
                            src="/img/style/picto-check.svg">{{ __('common.available-cross-device') }}
                    </li>
                    <li class="benefit"><img
                            src="/img/style/picto-check.svg">{{ __('trads.Tablatures-included') }}</li>
                    <li class="benefit"><img
                            src="/img/style/picto-check.svg">{{ __('trads.Unlimited-access') }}</li>
                    <li class="benefit"><img
                            src="/img/style/picto-check.svg">{{ __('trads.Cancel-anytime') }}</li>
                    <li class="benefit reverb-benefit"><span>+ bonus: </span>{{ __('trads.voucheronreverb') }}</li>
                </ul>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
    displayMessage () {
        if (this.message) {
            return this.message;
        }
        return this.__('giftcard.has-sent', {'name': this.sender_name});
    },
    ...mapState([
        'plan',
        'step',
        'message',
        'sender_name',
    ])
    },
    beforeMount() {
    }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>